import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RangeComponent } from './range.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { InputErrorModule } from '../input-error/input-error.module';

@NgModule({
  declarations: [
    RangeComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    InputErrorModule,
  ],
  exports: [
    RangeComponent
  ]
})
export class RangeModule { }
